$(function() {

    // modal
    var toTop = document.getElementsByClassName('pagetop');
    var header = document.getElementsByClassName('header');
    var featureSpecial = document.getElementsByClassName('feature_special');
    if (featureSpecial.length !== 0) {
        console.log(featureSpecial);
        // modal_weekend
        $('.js_special_modal_open').each(function() {
            $(this).on('click', function() {
                var target = $(this).data('target');
                var modal = document.getElementById(target);
                $(modal).fadeIn();
                // z-index
                $(header).addClass('is_display');
                $(toTop).addClass('is_display');
                return false;
            });
        });
        $('.js_special_modal_close').on('click', function() {
            $('.js_special_modal').fadeOut();
            $(header).removeClass('is_display');
            $(toTop).removeClass('is_display');
            return false;
        });
    } else {
        // modal_shop
        $('.js_special_modal_open').each(function() {
            $(this).on('click', function() {
                var target = $(this).data('target');
                var modal = document.getElementById(target);
                $(modal).fadeIn();
                return false;
            });
        });
        $('.js_special_modal_close').on('click', function() {
            $('.js_special_modal').fadeOut();
            return false;
        });
    };

    // tab 
    $(function() {
        $('.js_special_tab').on('click', function() {
            var target = $('.js_special_tab').index(this);
            $('.js_special_tab').removeClass('is_active');
            $('.js_special_tab').eq(target).addClass('is_active');
            $('.js_special_panel').removeClass('is_show');
            $('.js_special_panel').eq(target).addClass('is_show');
            return false;
        });
    });

    // tab_link
    $(function() {
        var url = location.href;
        if(url.indexOf('?') != -1) {
            var params = url.split('?');
            var tabParams = params[1].split('=');
            var tab = tabParams[1].split('&');
            if($(tab).length){
                var tabName = String(tab[0]);
                } else{
                var tabName = 'tab1';
            };
        };
        $('.js_special_tab').removeClass('is_active');
        $('.js_special_panel').removeClass('is_show');
        var index = $('.js_special_tab#' + tabName).index();
        $('.js_special_tab').eq(index).addClass('is_active');
        $('.js_special_panel').eq(index).addClass('is_show');
    });
      
    // coupon
    $(function() {
        $('.js_copy_target').on('click', function() {
            var target = $(this).data('target');
            var coupon = document.getElementById(target);
            coupon.select();
            document.execCommand("copy");
        });
    });
    
});